import React,{useState} from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
// import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
// import { blue, red } from '@mui/material/colors';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../FormikControl";

function MobileAddPreapproval() {
  const navigate = useNavigate();
  const [seletedType, setSeletedType] = useState(false);
  const onSeletedTypefun = () => {
    setSeletedType(!seletedType);
  }
  const initialValues = {
    first_name: "",
    last_name: "",
    phone: "",
    email:""
  };

  const validationSchema = Yup.object({
    first_name: Yup.string().required("Required"),
    last_name: Yup.string().required("Required"),
    phone: Yup.string().required("Required"),
    email: Yup.string().required("Required"),
  });

  const onSubmit = (values) => console.log("Form Data", values);
  return (
    <div className='MainView'> 
    <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/Visitor")}
        />
        <h1>Add Preapproval</h1>
    </div>
    <div className='topSpace'></div>
    <div className='mainWrapperListView'>
      <div className="famDetailsListInrMob">
          <div className='margInline15'>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => (
              <Form>
            <div className='FormView'>
              <div className='lebalInputView'>
                <FormikControl
              		control="input"
              		type="text"
              		label="First Name"
              		placeholder="Enter First Name"
              		labelclassName="inputLebal"
              		name="first_name"
              		className="titleInput"
            		/>
              </div>
              <div className='lebalInputView'>
                <FormikControl
              		control="input"
              		type="text"
              		label="Last Name"
              		placeholder="Enter Last Name"
              		labelclassName="inputLebal"
              		name="last_name"
              		className="titleInput"
            		/>
              </div>
              <div className='lebalInputView'>
                <FormikControl
              		control="input"
              		type="text"
              		label="Phone"
              		placeholder="Enter phone number"
              		labelclassName="inputLebal"
              		name="phone"
              		className="titleInput"
            		/>
              </div>
              <div className='lebalInputView'>
                <FormikControl
              		control="input"
              		type="text"
              		label="Email"
              		placeholder="Enter Email"
              		labelclassName="inputLebal"
              		name="email"
              		className="titleInput"
            		/>
              </div>
              <div className='DateTimeOuterView'>
                <div className='DateTimeView'>
                <p className='inputLebal'>Select Start Date</p>
                <input type='date' value="2024-07-12"  className='datetimeinputPolls'/>
                </div>
                <div className='DateTimeView'>
                <p className='inputLebal'>Select Start Time</p>
                <input type='time' value="19:30" className='datetimeinputPolls'/>
                </div>
              </div>
              <div className='DateTimeOuterView'>
              <div className='DateTimeView'>
                <p className='inputLebal'>Select End Date</p>
                <input type='date' value="2024-07-12"  className='datetimeinputPolls'/>          
              </div>
              <div className='DateTimeView'>
                <p className='inputLebal'>Select End Time</p>
                <input type='time' value="19:30" className='datetimeinputPolls'/>
              </div>
              </div>
              <div className='typePreView margineTopAdd'>
                <p className='inputLebal'>Type</p>
                <div style={{display:'flex', gap:10}}>
                <div className={seletedType?'preAppTypeView preSelected':'preAppTypeView'}onClick={()=>onSeletedTypefun()}>
                    <p className={seletedType ? 'preApprovalTypeTxt preSelectedTxt':'preApprovalTypeTxt'}>Delivery Person</p>
                </div>
                <div className={seletedType?'preAppTypeView preSelected':'preAppTypeView'}onClick={()=>onSeletedTypefun()}>
                    <p className={seletedType ? 'preApprovalTypeTxt preSelectedTxt':'preApprovalTypeTxt'}>Visitor</p>
                </div>
                <div className={seletedType?'preAppTypeView preSelected':'preAppTypeView'}onClick={()=>onSeletedTypefun()}>
                    <p className={seletedType ? 'preApprovalTypeTxt preSelectedTxt':'preApprovalTypeTxt'}>Guest</p>
                </div>
                </div>
              </div>
              <div className='margineTopAdd'>
                <button className='submitButton' type='submit'>Add Preapproval</button>
              </div>
            </div>
            </Form>
            )}
          </Formik>
          </div>
      </div>
    </div>
    </div>
  )
}

export default MobileAddPreapproval